import {React, useState, useEffect} from 'react'
import Table from '@mui/material/Table'
import { useRecordContext, useTranslate } from 'react-admin'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import {Button, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Skeleton,
  TextField} from '@mui/material'
import {commentsService} from 'src/services/reservation/comments/comments.service'
import { getLoggedUser } from 'src/helper/localStore/getLoggedUser'
import { Delete, Edit } from '@mui/icons-material'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import {PERMISSION_CREATE, PERMISSION_EDIT, PERMISSION_DELETE} from 'src/helper/Permission'
import { HasPermission } from 'src/helper/HasPermission'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { ShowCard } from 'src/components/uiElements/cards/ShowCard'
import { timeZoneFormat } from '../../helper/argToTimezoneFormat'
import { useComments } from './CommentsContext'

export const CommentsCardComponent = () => {
    const item = useRecordContext()
    const itemId = item?.item_id
    const [openAddModal, setOpenAddModal] = useState(false)
    const [message, setMessage] = useState('')
    const {reloadGrid, setReloadGrid} = useComments()
    const [comments, setComments] = useState([])
    const [idToEdit, setIdToEdit] = useState(null)
    const [idToDelete, setIdToDelete] = useState(null)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [loggedUserId, setLoggedUserId] = useState('')
    const [commentsLoading, setCommentsLoading] = useState(false)
    const translate = useTranslate()
    const loggedUser = getLoggedUser()

    const getComments = async() =>{
      setCommentsLoading(true)
      const loggedUserData = await getUserByHash(loggedUser.hashuser)
      setLoggedUserId(loggedUserData.user_id)
      await commentsService.getCommentsById(itemId).
      then(async res=>{
        setComments(res.data)
      })
      .catch(err=>console.log("err", err))
      .finally(()=>{
        setCommentsLoading(false)
      })
    }

    const getUserByHash =async (hash) => {
      try{
        return await reservationServices.userReservtionByHash(hash).then((usr)=>{
          return usr
        }
        )
      } catch(error) {
        console.log("No existe usuario")
      }
      
    }

    const addComment = async () =>{
      await commentsService.postComment(itemId, message)
      .then(res=>{
        setReloadGrid(!reloadGrid)
      }).catch(err=>console.log("err", err))
      .finally(()=>{
        setOpenAddModal(false)
        setMessage(null)
      })
    }

    const formatDateTime = (dateTime) => {
      if(dateTime){
        const date = dateTime.split(' ')[0]
        const time = dateTime.split(' ')[1]
        const separatedTime = time.split(':')

        const hours = separatedTime[0]
        const minutes = separatedTime[1]
        const seconds = separatedTime[2]
  
        const day = date.split('-')[0]
        const month = date.split('-')[1]
        const year = date.split('-')[2]
  
        return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes
      }
      return dateTime
    }

    useEffect(()=>{
      getComments()
    },[reloadGrid])

    const deleteComment = async () => {
      if(idToDelete){
        await commentsService.deleteComment(idToDelete).then((res)=>{
          setReloadGrid(!reloadGrid)
        }).finally(()=>{
          setIdToDelete(null)
          setConfirmDelete(false)
          setOpenDeleteModal(false)
        })
      }
      
    }

    useEffect(()=>{
      if(confirmDelete){
        deleteComment()
      }
    }, [confirmDelete])

    const editComment = async() =>{
      
      await commentsService.editComment(idToEdit, itemId, message).then((res)=>{
        setReloadGrid(!reloadGrid)
      }).finally(()=>{
        setIdToEdit(null)
        setOpenAddModal(false)
        setMessage(null)
      })
    }
    return(
        <>
        <ShowCard 
          title={translate('ra.field.comments')}
          actionButtonJustify='flex-end'
          actionButtonText={translate('ra.action.add_comment')}
          actionButtonStyle={{ width: 'fit-content' }}
          onClickButton={() => setOpenAddModal(true)}
        >
          <TableContainer component={Paper} sx={{ marginY: '30px' }}>
            <Table sx={{ minWidth: 650 }} aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell >{translate('ra.field.message')}</TableCell>
                  <TableCell align='left'>{translate('ra.field.created_at')}</TableCell>
                  <TableCell align='left'>{translate('ra.field.updated_at')}</TableCell>
                  <TableCell align='left'>{translate('ra.auth.username')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  commentsLoading ? 
                  <TableRow>
                  {[...Array(4)].map((_, i) => (
                    <TableCell key={i}>
                      <Skeleton variant='rectangular' width={'100%'} height={20} />
                    </TableCell>
                  ))}
                </TableRow>
                  :
                  comments?.map((row) => {
                    const { message, created_at, updated_at, user } =
                      row
                    return (
                      <>
                        <TableRow
                          key={row.id}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                            backgroundColor: 'white',
                          }}
                        >
                          <TableCell align='left'>{message}</TableCell>
                          <TableCell align='left'>{formatDateTime(timeZoneFormat(created_at))}</TableCell>
                          <TableCell align='left'>{formatDateTime(timeZoneFormat(updated_at))}</TableCell>
                          <TableCell align='left'>
                            {user}
                          </TableCell>
                          <TableCell align='left'>
                            {
                              <div style={{display:'flex', flexDirection:'row'}}>
                                <HasPermission permission={PERMISSION_DELETE} resource={'comments'}>
                                  <Button
                                    size='small'
                                    startIcon={<Delete /> }
                                    color={ 'error'}
                                    onClick={(e) => {setOpenDeleteModal(true)
                                                  setIdToDelete(row.id)
                                                }}
                                  >
                                    {}
                                  </Button>
                                </HasPermission>
                                <HasPermission permission={PERMISSION_EDIT} resource={'comments'}>
                                  <Button
                                    size='small'
                                    disabled = {row.user_id != loggedUserId}
                                    startIcon={ <Edit />}
                                    onClick={()=>{
                                      setMessage(row.message)
                                      setOpenAddModal(true)
                                      setIdToEdit(row.id)
                                    }}
                                  >
                                    {}
                                  </Button>
                                </HasPermission>
                              </div>
                            }
                          </TableCell>
                        </TableRow>
                      </>
                    )
                  })
                  }
              </TableBody>
            </Table>
          </TableContainer>
          </ShowCard>
        <Dialog open={openAddModal} fullWidth onClose={() => setOpenAddModal(false)}>
          <DialogTitle>{translate('ra.field.comments')}</DialogTitle>
          <DialogContent>
              <TextField
                  value={message}
                  multiline
                  onChange={(e) => setMessage(e.target.value)}
                  size='medium'
                  inputProps={{ maxLength: 500 }}  
                  style={{
                    maxWidth: '100%'
                  }}
                  fullWidth
                />
          </DialogContent>
          <DialogActions>
            <Button
              variant='outlined'
              onClick={() => {
                setMessage('')
                setOpenAddModal(false)
              }}
            >
              {translate("ra.action.cancel")}
            </Button>
            <Button variant='contained' onClick={idToEdit ? editComment :addComment} >
            {translate("ra.action.acept")}
            </Button>
          </DialogActions>
        </Dialog>
        <ConfirmationDialog
          title={translate('ra.message.delete_comment')}
          buttonConfirmText={translate('ra.message.yes')}
          buttonCancel={translate('ra.message.no')}
          setOpen={setOpenDeleteModal}
          setConfirm={setConfirmDelete}
          open={openDeleteModal}
        />
    </>
        
    )
}